import type { ReservationStatus, UnitBaseStatus } from './reservation-status.js';

// ─── Media format labels ──────────────────────────────────────
// Source: apps/mockups/src/data/media-inventory.ts (single source of truth)

export const MEDIA_FORMAT_LABELS: Record<string, string> = {
  billboard12: 'Billboard 12m²',
  billboard18: 'Billboard 18m²',
  billboard27: 'Billboard 27m²',
  billboard32: 'Billboard 32m²',
  billboard36: 'Billboard 36m²',
  billboard48: 'Billboard 48m²',
  billboard_other: 'Billboard (inny)',
  backlight18: 'Backlight 18m²',
  backlight32: 'Backlight 32m²',
  backlight_other: 'Backlight (inny)',
  citylight: 'Citylight',
  cityscroll: 'Cityscroll',
  highway: 'Autostrada',
  wielki_format: 'Wielki format',
  wall: 'Mural',
  digital: 'Digital',
  rm_digital: 'RM Digital',
  slup: 'Słup',
  other: 'Inny',
};

// ─── Reservation status labels ────────────────────────────────

export type DisplayReservationStatus = UnitBaseStatus | ReservationStatus | 'POTENTIAL';

export const RESERVATION_STATUS_LABELS: Record<DisplayReservationStatus, string> = {
  FREE: 'Wolny',
  ASK_AVAILABILITY: 'Niepotwierdzony',
  OPTION: 'Stałka',
  SOFT_RESERVATION: 'Miękka rezerwacja',
  HARD_RESERVATION: 'Twarda rezerwacja',
  SOLD: 'Sprzedany',
  POTENTIAL: 'Potencjał',
};

// ─── Reservation status badge variants ───────────────────────

export const RESERVATION_STATUS_VARIANTS: Record<
  DisplayReservationStatus,
  'success' | 'warning' | 'info' | 'destructive'
> = {
  FREE: 'success',
  ASK_AVAILABILITY: 'warning',
  OPTION: 'warning',
  SOFT_RESERVATION: 'info',
  HARD_RESERVATION: 'info',
  SOLD: 'destructive',
  POTENTIAL: 'warning',
};
